<div class="fill-width flex flex-col gap-[30px] justify-start items-start">
  <div data-at-metadata class="fill-width flex flex-col justify-start items-start">
    <p>{{ 'DIAGNOSTICS.DEFAULT_TEMPLATE.METADATA' | translate }}:</p>
    <app-diagnostics-dynamic-metadata-component
      [vddName]="vddName"
      [logicalLink]="logicalLink"
    ></app-diagnostics-dynamic-metadata-component>
  </div>
  <div data-at-structure class="fill-width flex flex-col justify-start items-start">
    <p>{{ 'DIAGNOSTICS.DEFAULT_TEMPLATE.PARAMETER_VALUES' | translate }}:</p>
    <app-diagnostics-dynamic-structure-component
      [vddName]="vddName"
      [logicalLink]="logicalLink"
      [isVddEditable]="isVddEditable"
      [parameterId]="parameterId"
      [diagnosticsFormGroupService]="diagnosticsFormGroupService"
    ></app-diagnostics-dynamic-structure-component>
  </div>
</div>
